// extracted by mini-css-extract-plugin
export default {"TranslateBtns":"TranslateBtns_TranslateBtns__UTFTa","LangBtn":"TranslateBtns_LangBtn__3Erda","CurrentLang":"TranslateBtns_CurrentLang__vBYqu"};